module.exports = __webpack_public_path__ + "website/img/hzhb.55696501.svg";